import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RelatedPostsDataService {
  private relatedPostsData: any;
  constructor() { }

  set data(value: any) {
    this.relatedPostsData = value;
  }

  get data(): any {
    return this.relatedPostsData;
  }
}